export default __webpack_public_path__ + "static/media/Flight.cb436dce.png";